/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { euiDefaultUnit } from '../Constants';

export const euiUnits = [
  {
    value: 'kWh/sq. ft',
    text: 'kWh/sqft',
    factor: 0.293071
  },
  {
    value: 'kWh/sq. m',
    text: 'kWh/sqm',
    factor: 3.15459
  },
  {
    value: 'MWh/sq. ft',
    text: 'MWh/sqft',
    factor: 0.000293071
  },
  {
    value: 'MWh/sq. m',
    text: 'MWh/sqm',
    factor: 0.00315459
  },
  {
    value: 'kBTU/sq. ft',
    text: 'kBTU/sqft',
    factor: 1
  },
  {
    value: 'kBTU/sq. m',
    text: 'kBTU/sqm',
    factor: 10.7639
  },
  {
    value: 'MBTU/sq. ft',
    text: 'MBTU/sqft',
    factor: 0.001
  },
  {
    value: 'MBTU/sq. m',
    text: 'MBTU/sqm',
    factor: 0.0107639104
  },
  {
    value: 'GJ/sq. ft',
    text: 'GJ/sqft',
    factor: 0.00105506
  },
  {
    value: 'GJ/sq. m',
    text: 'GJ/sqm',
    factor: 0.0113565
  }
];

export const getEuiUnitDisplayName = (euiUnitValue: string | undefined) => {
  if (!euiUnitValue) {
    return '';
  }
  const preferredEuiUnit = euiUnits.find((r) => r.value === euiUnitValue);
  if (!preferredEuiUnit) {
    return '';
  }
  return preferredEuiUnit.text;
};

export const handleEuiUnitConversion = (
  value: number,
  fromUnit: string,
  toUnit: string
) => {
  let measurementUnit: string;
  if (fromUnit && fromUnit.toLowerCase() === 'kbtu') {
    measurementUnit = euiDefaultUnit;
  } else {
    measurementUnit = fromUnit;
  }
  const preferredEuiUnitValue = euiUnits.find((i) => i.value === toUnit)
    ?.factor;
  const euiUnitValue = euiUnits.find((i) => i.value === measurementUnit)
    ?.factor;
  if (preferredEuiUnitValue && euiUnitValue) {
    return (value * preferredEuiUnitValue) / euiUnitValue;
  } else {
    return value;
  }
};
